import React from "react";
import { connect } from "react-redux";

import ExistingUser from "./ExistingUser";
import NewUser from "./NewUser";

class InviteForm extends React.Component {
  render() {
    const { origin, users, companyId, sudoSiteId, siteName, originType, originId } = this.props; // companyId, sudoSiteId & siteName only relevant when origin is SingleSite/Companies

    const userExistsOnSystem = users.actions.search.error.status !== 422;

    return userExistsOnSystem
      ? <ExistingUser
          origin={origin}
          companyId={companyId}
          sudoSiteId={sudoSiteId}
          siteName={siteName}
          originType={originType}
          originId={originId}
        />
      : <NewUser
          origin={origin}
          companyId={companyId}
          sudoSiteId={sudoSiteId}
          siteName={siteName}
          originType={originType}
          originId={originId}
        />;
  }
}
const mapStateToProps = (state, props) => {
  return {
    users: state.users
  };
};
export default connect(mapStateToProps)(InviteForm);
